'use strict';

Object.defineProperty(exports, "__esModule", { value: true });
exports.Http = void 0;
var tslib_1 = require("tslib");
var session_1 = require("../session/session");
var Http = /** @class */ (function () {
    function Http(url, brand, key, driver, isCoreX) {
        this.url = url;
        this.brand = brand;
        this.key = key;
        this.driver = driver;
        this.isCoreX = isCoreX;
        var prefix = isCoreX ? 'corex' : 'igc';
        this.baseUrl = this.url + "/" + prefix + "/" + this.brand;
        if (this.driver === undefined) {
            if (typeof fetch === 'undefined') {
                throw new Error('No http driver is passed and "fetch" is not available');
            }
            this.driver = fetch.bind();
        }
    }
    Http.prototype.request = function (endpoint, params) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var resp, _a, _b, _c, result;
            var _d;
            return tslib_1.__generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        _a = this.driver;
                        _b = [this.makeUrl(endpoint)];
                        _d = {
                            method: 'POST'
                        };
                        _c = [{ 'Content-Type': 'application/json; charset=utf-8', 'X-API-Key': this.key }];
                        return [4 /*yield*/, this.getAuthorisationParams()];
                    case 1: return [4 /*yield*/, _a.apply(this, _b.concat([(_d.headers = tslib_1.__assign.apply(void 0, _c.concat([(_e.sent())])),
                                // TODO: this should be changed so we can support form data
                                _d.body = JSON.stringify(params),
                                _d.cache = 'no-cache',
                                _d)]))];
                    case 2:
                        resp = _e.sent();
                        return [4 /*yield*/, resp.json()];
                    case 3:
                        result = _e.sent();
                        if (resp.status === 400 && result.errors) {
                            // eslint-disable-next-line no-throw-literal
                            throw {
                                status: resp.status,
                                errorCodes: result.errors,
                            };
                        }
                        if (result.err) {
                            throw result.err;
                        }
                        if (result.errors) {
                            throw result.errors;
                        }
                        return [2 /*return*/, result.res];
                }
            });
        });
    };
    Http.prototype.getAuthorisationParams = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var accessToken;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.isCoreX) return [3 /*break*/, 2];
                        return [4 /*yield*/, session_1.session.getAccessToken()];
                    case 1:
                        accessToken = _a.sent();
                        return [2 /*return*/, {
                                'Authorization': accessToken ? "Bearer " + accessToken : '',
                                'x-api-sid': session_1.session.getId() || '',
                            }];
                    case 2: return [2 /*return*/, {
                            'X-API-Session-Id': session_1.session.getId() || '',
                        }];
                }
            });
        });
    };
    /**
     * Uploads a file or a list of files and reports the upload progress
     * @param endpoint where to upload the file(s)
     * @param files file(s) to upload
     * @param onProgressChange event handler for progress change
     * @param params Request parameters
     */
    Http.prototype.upload = function (endpoint, files, onProgressChange, params) {
        var _this = this;
        return new Promise(function (resolve, reject) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var request, data, paramKeys, fileCount, handleError, headers;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        request = new XMLHttpRequest();
                        data = new FormData();
                        paramKeys = params ? Object.keys(params) : [];
                        paramKeys.forEach(function (key) { return data.append(key, params[key]); });
                        fileCount = 1;
                        if (files instanceof FileList) {
                            Array.from(files).forEach(function (file, i) {
                                data.append("file" + i, file);
                            });
                            fileCount = files.length;
                        }
                        else {
                            data.append('file0', files);
                        }
                        handleError = function (error) {
                            reject(error);
                            if (onProgressChange) {
                                onProgressChange(0, true);
                            }
                        };
                        request.addEventListener('load', function () {
                            try {
                                var response = JSON.parse(request.response);
                                if (_this.isErrorResponse(response)) {
                                    handleError(new Error('Unexpected server response on file upload: ' +
                                        request.response));
                                }
                                if (onProgressChange) {
                                    onProgressChange(1, false);
                                }
                                resolve();
                            }
                            catch (e) {
                                handleError(e);
                            }
                        });
                        request.addEventListener('abort', handleError);
                        request.addEventListener('error', handleError);
                        request.addEventListener('timeout', handleError);
                        request.upload.addEventListener('progress', function (e) {
                            if (onProgressChange) {
                                onProgressChange(e.loaded / e.total, false);
                            }
                        });
                        request.open('POST', this.makeUrl(endpoint) +
                            ("?fieldsQty=" + paramKeys.length) +
                            ("&filesQty=" + fileCount));
                        request.setRequestHeader('X-API-Key', this.key);
                        return [4 /*yield*/, this.getAuthorisationParams()];
                    case 1:
                        headers = _a.sent();
                        Object.keys(headers).forEach(function (key) {
                            request.setRequestHeader(key, headers[key]);
                        });
                        request.send(data);
                        return [2 /*return*/];
                }
            });
        }); });
    };
    Http.prototype.isErrorResponse = function (response) {
        if (!response || !response.res) {
            return true;
        }
        return !this.isCoreX && !response.res.success;
    };
    Http.prototype.get = function (url) {
        return this.driver(url).then(function (res) { return res.text(); });
    };
    Http.prototype.makeUrl = function (endpoint) {
        return this.baseUrl + "/" + endpoint;
    };
    return Http;
}());
exports.Http = Http;
